import themes from '../../theming/themes.js';
import React from 'react';
import _Container from '../../components/Container/index.js';
import lfgTagline from './assets/lfg-tagline-footer.svg.js';
import FooterLink from './components/FooterLink.js';
import IconLinks from './components/IconLinks.js';
import StyledFooter from './components/StyledFooter.js';

var DefaultCopyright = function DefaultCopyright() {
  return /*#__PURE__*/React.createElement("div", {
    className: "copyright"
  }, "\xA9 ".concat(new Date(2024, 0, 0).getFullYear(), " Lincoln National Corporation. All rights\n      reserved"));
};
var defaultDisclaimer = 'Lincoln Financial is the marketing name for Lincoln National Corporation and insurance company affiliates, including The Lincoln National Life Insurance Company, Fort Wayne, IN, and in New York, Lincoln Life & Annuity Company of New York, Syracuse, NY. Variable products distributed by broker/dealer-affiliate Lincoln Financial Distributors, Inc., Radnor, PA. Securities and investment advisory services offered through other affiliates.';
var defaultLogoText = /*#__PURE__*/React.createElement("p", {
  style: {
    fontSize: '16px',
    marginTop: '0.5rem',
    marginRight: '1.25rem'
  }
}, /*#__PURE__*/React.createElement("img", {
  height: "44",
  src: lfgTagline,
  alt: "Lincoln Financial Tagline"
}));
var Footer = function Footer(props) {
  var Links = props.links,
    _props$content = props.content,
    content = _props$content === void 0 ? defaultDisclaimer : _props$content,
    lcn = props.lcn,
    _props$copyright = props.copyright,
    Copyright = _props$copyright === void 0 ? DefaultCopyright : _props$copyright,
    _props$logo = props.logo,
    _props$tagline = props.tagline,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? themes.secureSite : _props$theme,
    showSocialIcons = props.showSocialIcons,
    _props$logoText = props.logoText,
    logoText = _props$logoText === void 0 ? defaultLogoText : _props$logoText;
  return /*#__PURE__*/React.createElement(StyledFooter, {
    theme: theme
  }, /*#__PURE__*/React.createElement(_Container, {
    theme: theme
  }, /*#__PURE__*/React.createElement("div", {
    className: "footer-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lfg-logo-img"
  }, logoText), /*#__PURE__*/React.createElement("div", {
    className: "nav-copyright",
    style: {
      marginLeft: '-1.5rem'
    }
  }, /*#__PURE__*/React.createElement("nav", {
    className: "d-flex flex-wrap nav-links"
  }, /*#__PURE__*/React.createElement("ul", {
    role: "list",
    style: {
      lineBreak: 'anywhere',
      marginLeft: '-0.625rem'
    }
  }, /*#__PURE__*/React.createElement(Links, null))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Copyright, null))), showSocialIcons ? /*#__PURE__*/React.createElement(IconLinks, {
    theme: theme
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: "footer-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "footer-col",
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "lcn"
  }, lcn)), /*#__PURE__*/React.createElement("div", {
    className: "disclaimer"
  }, content))));
};
Footer.FooterLink = FooterLink;

export default Footer;
